import styled from '@emotion/styled';

export const FiltersModalForm = styled.form`
    display: grid;
    grid-template-columns: 1fr 1fr;
`;
